/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Imagen_Interactiva from "./Sub_Componentes/Imagen_Interactiva";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const {sCell, masSM} = useResponsive()

    return (

        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{ml: sCell ? 0 : -6}}>
                    <Grid
                        container
                        direction={'row-reverse'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{px: sCell ? 4 : 6}}>
                            <Imagen_Interactiva/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{mt: sCell ? 6 : 0}}>
                            <Grid
                                container
                                justifyContent={sCell ? 'flex-start' : 'flex-end'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}

                            >


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      justifyContent={sCell ? 'flex-start' : 'flex-end'}>
                                    <Typography
                                        sx={{
                                            fontSize: sCell ? 32 : 40,
                                            fontWeight: 900,
                                            lineHeight: 0.9,
                                            textAlign: !masSM ? 'left' : 'right',
                                            pl: !masSM ? 0.5 : 0
                                        }}>
                                        HOLA!
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography
                                        sx={{
                                            fontSize: !masSM ? 60 : 90,
                                            fontWeight: 900,
                                            lineHeight: 0.9,
                                            textAlign: sCell ? 'left' : 'right'
                                        }}>
                                        SOY JOSE ARTURO
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-end', my: 1}}>
                                    <Typography sx={{
                                        fontSize: 16,
                                        fontWeight: 400,
                                        lineHeight: 1.1,
                                        textAlign: sCell ? 'left' : 'right',
                                        pl: !masSM ? 0.5 : 0
                                    }}>
                                        Las mejores marcas nacen con estrategia… y buen café.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 11}}
                                      sx={{justifyContent: 'flex-end', mt: 6}}>
                                    <Typography sx={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        lineHeight: 1.1,
                                        textAlign: sCell ? 'center' : 'right',
                                        fontFamily: 'Rethink Sans'
                                    }}>
                                        <span style={{fontWeight: 600}}>Llevo más de 12 años en esta industria</span>
                                        <br/>
                                        y si algo tengo claro es que las mejores historias se escriben entre intentos,
                                        aprendizajes… y las ganas de volver a intentarlo.
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Portada